import { createFileRoute } from '@tanstack/react-router'
import { throwLegacyRedirect } from '../lib/legacy-redirect'

export const Route = createFileRoute('/ceramic-coating-geelong')({
  beforeLoad: ({ location }) => {
    throwLegacyRedirect(location.pathname, location.searchStr)
  },
  component: () => null,
  head: () => ({
    title: 'Ceramic Protection | Autoglow Detailing',
    meta: [{ name: 'robots', content: 'noindex,follow' }],
  }),
})
